import deburr from "lodash/deburr";
import axios from "axios";
import React, {Component} from "react";
import AutocompleteSearch from "../AutocompleteSearch";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core";
import {urlConfig} from "../config";

const styles = theme => ({});

class MomentsPlaylistSearch extends Component {

    handleMomentPlaylistSearchRequest = (value) => {

        const inputValue = deburr(value.trim()).toLowerCase();

        const inputLength = inputValue.length;
        let count = 0;

        let serverUrl = `${urlConfig.momentsServiceUrl}/moments?title=${inputValue}`;

        const momentsPlaylistSearchInstance = axios.create({
            baseURL: `${serverUrl}`
        });

        return momentsPlaylistSearchInstance.get()

    };

    handleSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
        let suggestionValueParsed = suggestion.id;

        this.props.handleSuggestionSelect(suggestionValueParsed, suggestion);
    };

    getSuggestions = (value, suggestions) => {
        const inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;
        let count = 0;

        return inputLength === 0
            ? []
            : suggestions.filter(suggestion => {
                const keep =
                    count < 5 && suggestion.title.slice(0, inputLength).toLowerCase() === inputValue;

                if (keep) {
                    count += 1;
                }

                return keep;
            });
    };

    getSuggestionValue = (suggestion) => {
        return suggestion.title
    };


    renderSuggestion = (suggestion, {query, isHighlighted}) => {
        const matches = match(suggestion.title, query);
        const parts = parse(suggestion.title, matches);

        return (
            <MenuItem selected={isHighlighted} component="div">
                <div>
                    {parts.map((part, index) => {
                        return part.highlight ? (
                            <span key={String(index)} style={{fontWeight: 500}}>
              {part.text}
            </span>
                        ) : (
                            <strong key={String(index)} style={{fontWeight: 300}}>
                                {part.text}
                            </strong>
                        );
                    })}
                </div>
            </MenuItem>
        );
    };

    render() {
        return (<AutocompleteSearch
            handleSuggestionSelected={this.handleSuggestionSelected}
            inputSearchText={this.props.inputSearchText}
            handleSuggestionSelect={this.props.handleSuggestionSelect}
            handleSearchRequest={this.handleMomentPlaylistSearchRequest}
            inputPlaceholder={'Search with Moments Playlist Title'}
            getSuggestions={this.getSuggestions}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}/>)
    }
}


MomentsPlaylistSearch.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
export default withStyles(styles, {withTheme: true})(MomentsPlaylistSearch);